import { Component } from '@angular/core';

import { Observable } from 'rxjs';

import { FullScreenLoaderService } from './full-screen-loader.service';

/**
 * This component adds a full screen overlay and shows a loading icon
 */
@Component({
    selector: 'cw-full-screen-loader',
    templateUrl: './full-screen-loader.component.html',
    styleUrls: ['./full-screen-loader.component.scss'],
    standalone: false,
})
export class FullScreenLoaderComponent {
    loading$: Observable<boolean> = this.loader.loading;

    constructor(private loader: FullScreenLoaderService) {}
}
